import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import useSWR from 'swr';
import Fuse from 'fuse.js';

import SearchBox from '../Searchbox';
import ServiceGrid from './ServiceGrid';
import ServiceCard from './ServiceCard';

import useUserData from '../util/hooks/useUserData'
import ErrorMessage from '../Common/ErrorMessage';

const fuse = new Fuse([], {
	findAllMatches: true,
	threshold: 0.3,
	keys: ['serviceCode', 'info.title', 'info.description', 'info.keywords']
});

const serviceSortFn = (s1, s2) => (s1.info && s1.info.title).localeCompare(s2.info && s2.info.title);

export default () => {

	const { versionSlug } = useParams();

	const { isLoading, isDev } = useUserData();

	const basePath = isDev ? 'private' : 'versions';

	const { data, error } = useSWR(isLoading ? null : `/${basePath}/${versionSlug}/services/list.json`);

	const [search, setSearch] = useState('');

	if(isLoading) {
		return null;
	}

	if(error) {
		return (
			<ErrorMessage>{error.message}</ErrorMessage>
		);
	}

	if(data) {

		let services = data.sort(serviceSortFn);

		if(search.trim()) {
			fuse.setCollection(services);
			services = fuse.search(search)
				.map(({ item }) => item);
		}

		return (
			<React.Fragment>
				<SearchBox value={search} onSearch={setSearch} />
				<ServiceGrid>
					{services.map(serviceData => (
						<ServiceCard key={serviceData.serviceCode} versionSlug={versionSlug} serviceData={serviceData}/>
					))}
				</ServiceGrid>
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<SearchBox value={search} onSearch={setSearch} />
			<ServiceGrid>
				{([0,1,2,3,4,5,6,7]).map(index => (
					<ServiceCard key={`loading-${index}`} loading={true}/>
				))}
			</ServiceGrid>
		</React.Fragment>
	);
};
